import { licenseActions } from "../actions";
const {
  FETCH_INITIAL_STATE,
  FETCH_LICENSES,
  FETCHING_LICENSES,
  FETCH_LICENSE,
  FETCHING_LICENSE,
  FETCH_LICENSE_ERROR,
  FETCH_LICENSES_ERROR,
  FETCHING_LICENSE_AREAS,
  FETCH_LICENSE_AREAS,
} = licenseActions;

const initialState = {
  fetching: {
    license: false,
    licenses: false
  },
  items: [],
  last_update: undefined,
  areaList: [],
  license: {},
  fetch_errors: {
    license: false,
    licenses: false
  }
};

const license = (state = initialState, action = "") => {
  switch (action.type) {
    case FETCH_INITIAL_STATE:
    return {
      ...state,
      items: []
    }
    case FETCH_LICENSES:
      return {
        ...state,
        last_update: action.last_update,
        items: action.items,
        fetching: { ...state.fetching, licenses: false },
        fetch_errors: {
          ...state.fetch_errors,
          licenses: false
        }
      };
    case FETCHING_LICENSES:
      return {
        ...state,
        fetching: { ...state.fetching, licenses: action.value }
      };
    // Single License
    case FETCH_LICENSE:
      return {
        ...state,
        license: action.license,
        fetching: { ...state.fetching, license: false },
        fetch_errors: {
          ...state.fetch_errors,
          license: false
        }
      };
    case FETCHING_LICENSE:
      return {
        ...state,
        fetching: { ...state.fetching, license: action.value }
      };
    // Erros
    case FETCH_LICENSES_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          licenses: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          licenses: true
        }
      };
    case FETCH_LICENSE_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          license: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          license: true
        }
      };
    case FETCHING_LICENSE_AREAS:
      return {
        ...state,
        fetching: {
          ...state.fetching, licenses: action.value
        }
      };
    case FETCH_LICENSE_AREAS:
      return {
        ...state,
        areaList: action.areasList,
        fetching: { ...state.fetching, licenses: false },
        fetch_errors: {
          ...state.fetch_errors,
          licenses: false
        }
      };
    default:
      return state;
  }
};

export default license;



// WEBPACK FOOTER //
// ./src/reducers/license.js